<script setup lang="ts">
import {
  IAutomationAppResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IAutomationAppResponseInstance'

interface Props {
  payload: {
    app?: IAutomationAppResponseInstance | null
  }
  entityId: string
}

const props = withDefaults(defineProps<Props>(), {
  payload: () => ({app: null}),
})

function initial(name?: string, id?: string): string {
  const s = (name || id || 'A').trim()
  return s.slice(0, 1).toUpperCase()
}
</script>

<template>
  <div
    class="app-permission-entity-thumb"
    :style="{backgroundColor: props.payload?.app?.iconColor || undefined}"
  >
    <img
      v-if="props.payload?.app?.completedIconFileVariants?.[0]?.url"
      :src="props.payload.app.completedIconFileVariants[0].url"
      :alt="props.payload.app.name || ''"
      class="app-permission-entity-thumb-image"
    />
    <span v-else class="app-permission-entity-thumb-letter">
      {{initial(props.payload?.app?.name, props.entityId)}}
    </span>
  </div>
</template>

<style scoped lang="scss">
@use '../../../../styles/variables' as variables;

.app-permission-entity-thumb {
  background-color: map-get(variables.$colors, container-high);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.31rem;
  aspect-ratio: 1/1;
  border-radius: map-get(variables.$radiuses, radius-full);
  overflow: hidden;
}

.app-permission-entity-thumb-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: map-get(variables.$spacing, space-1);
}

.app-permission-entity-thumb-letter {
  font-size: map-get(variables.$textSizes, text-2xs);
  font-weight: 700;
  line-height: 1;
  color: map-get(variables.$colors, content-bright);
}
</style>
